import { Pipe, PipeTransform } from '@angular/core';
import { AngularDotcodesService } from './angular-dotcodes.service';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'dotcode',
})
export class DotcodePipe implements PipeTransform {
  constructor(private dotcodeService: AngularDotcodesService) { }

  transform(value: string, column: string): any {
    return this.dotcodeService.GetCode(column, value).pipe(map(c => {
      if (c) {
        return c.description;
      }
    }));
  }

}
